import React from 'react';
import styled, { keyframes } from 'styled-components/macro';
import { device } from '../../style/Sizes';
import { isMobile } from 'react-device-detect';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const SquaresContainerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 88px;
  height: 86px;
  width: 86px;
  overflow: hidden;

  @media ${device.maxHeightS} {
    margin-top: ${() => (isMobile ? '72px' : '')};
  }

  @media ${device.heightM} {
    margin-top: 130px;
    height: 114px;
    width: 114px;
  }

  @media ${device.heightL} {
    margin-top: ${() => (isMobile ? '200px' : '')};
  }
`;

const SquaresContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;

  @media ${device.heightM} {
    height: 80px;
    width: 80px;
  }
`;

const SquareWhite = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 94%;
  width: 94%;

  background: #861657;
`;

const SquareBlack = styled(SquareWhite)`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #93e1d8;

  animation: ${rotate} 10s infinite linear;
`;

const Squares = () => {
  return (
    <SquaresContainerContainer>
      <SquaresContainer>
        <SquareBlack>
          <SquareWhite>
            <SquareBlack>
              <SquareWhite>
                <SquareBlack>
                  <SquareWhite>
                    <SquareBlack>
                      <SquareWhite>
                        <SquareBlack>
                          <SquareWhite>
                            <SquareBlack>
                              <SquareWhite>
                                <SquareBlack>
                                  <SquareWhite>
                                    <SquareBlack>
                                      <SquareWhite>
                                        <SquareBlack>
                                          <SquareWhite>
                                            <SquareBlack>
                                              <SquareWhite>
                                                <SquareBlack>
                                                  <SquareWhite>
                                                    <SquareBlack>
                                                      <SquareWhite>
                                                        <SquareBlack>
                                                          <SquareWhite>
                                                            <SquareBlack>
                                                              <SquareWhite>
                                                                <SquareBlack>
                                                                  <SquareWhite>
                                                                    <SquareBlack>
                                                                      <SquareWhite>
                                                                        <SquareBlack>
                                                                          <SquareWhite>
                                                                            <SquareBlack>
                                                                              <SquareWhite></SquareWhite>
                                                                            </SquareBlack>
                                                                          </SquareWhite>
                                                                        </SquareBlack>
                                                                      </SquareWhite>
                                                                    </SquareBlack>
                                                                  </SquareWhite>
                                                                </SquareBlack>
                                                              </SquareWhite>
                                                            </SquareBlack>
                                                          </SquareWhite>
                                                        </SquareBlack>
                                                      </SquareWhite>
                                                    </SquareBlack>
                                                  </SquareWhite>
                                                </SquareBlack>
                                              </SquareWhite>
                                            </SquareBlack>
                                          </SquareWhite>
                                        </SquareBlack>
                                      </SquareWhite>
                                    </SquareBlack>
                                  </SquareWhite>
                                </SquareBlack>
                              </SquareWhite>
                            </SquareBlack>
                          </SquareWhite>
                        </SquareBlack>
                      </SquareWhite>
                    </SquareBlack>
                  </SquareWhite>
                </SquareBlack>
              </SquareWhite>
            </SquareBlack>
          </SquareWhite>
        </SquareBlack>
      </SquaresContainer>
    </SquaresContainerContainer>
  );
};

export default Squares;
